module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustra-3-cb0ecf586f6d27a9fbb285eac2e5413c.png";